import React, { useEffect, useState } from 'react';
import './home.css';
import { Link, useNavigate } from 'react-router-dom'
import Homeproduct from './home_product'
import { FaEye, FaHeart, FaTiktok, FaWhatsapp } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { AiFillInstagram } from "react-icons/ai";
import { IoCartOutline } from "react-icons/io5";

const Home = ({ addtocart }) => {
  const [newProduct, setNewProduct] = useState([]);
  const [featuredProduct, setFeaturedProduct] = useState([]);
  const [topProduct, setTopProduct] = useState([]);
  const [specialProduct, setSpecialProduct] = useState([]);
  const [trendingProduct, setTrendingProduct] = useState(Homeproduct);
  const [country, setCountry] = useState("US");
  const [currency, setCurrency] = useState("USD");
  const [exchangeRateLoaded, setExchangeRateLoaded] = useState(false);

  const navigate = useNavigate();

  // Navigate to detail page
  const detailpage = (product) => {
    navigate(`/product-detail/${product.id}`, { state: product });
  };

  const filtercate = (x) => {
    const filterproduct = Homeproduct.filter((curElm) => curElm.type === x);
    setTrendingProduct(filterproduct);
  };

  // Detect user's country
  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();
        setCountry(data.country_code || "US");
      } catch (err) {
        console.error("Location error:", err);
        setCountry("US");
      } finally {
        setExchangeRateLoaded(true);
      }
    };
    fetchCountry();
  }, []);

  // Currency logic (all prices are stored in Naira)
  const getDisplayedPrice = (price) => {
    const basePrice = Number(price);

    // Nigerians see Naira prices directly
    if (country === "NG") {
      return `₦${basePrice.toLocaleString()}`;
    }

    // Others see converted USD equivalent
    const usdRate = 1437; // current NGN/USD approximate
    const converted = basePrice / usdRate;

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      maximumFractionDigits: 2,
    }).format(converted);
  };

  const productcategory = () => {
    setSpecialProduct(Homeproduct.filter((x) => x.type === 'special'));
    setNewProduct(Homeproduct.filter((x) => x.type === 'top'));
    setFeaturedProduct(Homeproduct.filter((x) => x.type === 'jean'));
    setTopProduct(Homeproduct.filter((x) => x.type === 'fullfit'));
  };

  useEffect(() => {
    productcategory();
  }, []);

  return (
    <div className='home'>
      <div className='top_banner'>
        <div className='content'>
          <h2>Unique Styles</h2>
          <p>Make your first order</p>
          <Link to='/shop' className='link'>Shop Now</Link>
        </div>
      </div>

      <div className='trending'>
        <div className='container'>
          <div className='left_box'>
            <div className='header'>
              <div className='heading'>
                <h2 onClick={() => filtercate('special')}>Holiday Collection</h2>
              </div>
            </div>

            <div className='products'>
              <div className='container'>
                {specialProduct.map((curElm) => (
                  <div className='box' key={curElm.id}>
                    <div className='img_box'>
                      <img src={curElm.image} alt='' />
                      <div className='icon'>
                        <div onClick={() => detailpage(curElm)} className='icon_box'>
                          <FaEye />
                        </div>
                        <div className='icon_box'>
                          <FaHeart />
                        </div>
                      </div>
                    </div>
                    <div className='info'>
                      <h3>{curElm.Name}</h3>
                      <p>
                        {exchangeRateLoaded ? getDisplayedPrice(curElm.price) : "Loading..."}
                      </p>
                      <button className='btn' onClick={() => addtocart(curElm)}>
                        Add To Cart
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <Link to='/shop'><button>Show More</button></Link>
            </div>
          </div>

          <div className='right_box'>
            <div className='right_container'>
              <div className='testimonial'>
                <div className='head'>
                  <h3>our testimonial</h3>
                </div>
                <div className='detail'>
                  <div className='img_box'>
                    <img src='image/T1.avif' alt='testimonial'></img>
                  </div>
                  <div className='info'>
                    <h3>Our EMail</h3>
                    <h4>Style With Ease</h4>
                    <p>
                      My app has been on Ionic v1 for several years now and I have never seen this error before.
                      As v1 is now archived and no longer supported.
                    </p>
                  </div>
                </div>
              </div>

              <div className='newsletter'>
                <div className='head'>
                  <h3>newsletter</h3>
                </div>
                <div className='form'>
                  <p>join our mailing list</p>
                  <input type='email' placeholder='E-Mail' autoComplete='off'></input>
                  <button>Subscribe</button>
                  <div className='icon_box'>
                    <div className='icon'><AiFillInstagram /></div>
                    <div className='icon'><FaXTwitter /></div>
                    <div className='icon'><FaWhatsapp /></div>
                    <div className='icon'><FaTiktok /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='product_type'>
        <div className='container'>
          {[{ title: "New Product", data: newProduct },
            { title: "Featured Product", data: featuredProduct },
            { title: "Top Product", data: topProduct }].map((section, index) => (
            <div className='box' key={index}>
              <div className='header'>
                <h2>{section.title}</h2>
              </div>
              {section.data.map((curElm) => (
                <div className='productbox' key={curElm.id}>
                  <div className='img-box'>
                    <img src={curElm.image} alt='' />
                  </div>
                  <div className='detail'>
                    <h3>{curElm.Name}</h3>
                    <p>{getDisplayedPrice(curElm.price)}</p>
                    <div className='icon'>
                      <button onClick={() => detailpage(curElm)}><FaEye /></button>
                      <button><FaHeart /></button>
                      <button><IoCartOutline onClick={() => addtocart(curElm)} /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
